<template src="./DeviceLanding.html"></template>
<script>
// import { orderBy } from "@progress/kendo-data-query";
import { saveExcel } from "@progress/kendo-vue-excel-export";
import CommandCell from "@/components/CommandCellTemplate/CommandCellTemplate";
import { createNamespacedHelpers } from "vuex";
const { mapState } = createNamespacedHelpers("device");
import { MESSAGES } from "@/utils/constants";
import { notify, notifyApiError, notifyWarn } from "@/utils/notification-helper";
// import vendorService from "@/api/vendorService";
// const apiMethods = require("./../../../../api/api")
import DialogBox from "@/components/DialogBox";
import ViewDropdown from "@/components/ViewDropdown";
import { LOCAL_STORAGE_KEYS } from "@/utils/constants";
import moment from "moment-timezone";
// import Address from "@/views/Driver/Address";
// import AddressCell from "@/components/AddressCell";
import EmployeeErrors from "@/components/EmployeeError";
import AuditLog from "./AuditLog.vue"
export default {
  
  components: {
    DialogBox,
    ViewDropdown,
    AuditLog,
    EmployeeErrors,
  
  },
  data: function() {
    return {
      title: null,
      temp: {address: "sfwnrfwjnfjwf fwefnwjenfwefnwenf fwenf"},
      gridHeight: window.innerHeight - 120,
      // addoredit: false,
      gridData: [],
      searchText:"",
      serverSearchText:"",
      // skip: 0,
      // take: 25,
      // pageSize: 25,
      auditVals:[],
      // pageable: {
      //   previousNext: true,
      //   pageSizes: [5, 10, 25, 100, 500],
      //   pageSize: 10,
      // },
      add: true,
      sort: [{ field: "name", dir: "asc" }],
      filteredColumns: [],
      columns: [
        { hidden: false, field: "imei", title: "IMEI",  width: '250px',  checked: true, defaultSelected: true, },
        { hidden: false, field: "simCardNumber", title: "Sim Number",  width: '200px',  checked: true, defaultSelected: true, },
        { hidden: false, field: "deviceTypeId", title: "Device Type", cell: this.device, width: '150px', checked: true, defaultSelected: true, },
        { hidden: false, field: "tenantId", title: "Tenant", cell:this.tenants,  width: '150px', checked: true, defaultSelected: true, },
        { hidden: false, field: "vehicleRtoNumber", title: "Vehicle No.(RTO)",  width: '150px', checked: true, defaultSelected: true, },
        { hidden: false, field: "sensors", title: "Sensors", cell: this.sensors,  width: '150px', checked: true, defaultSelected: false, },
        { hidden: false, cell: CommandCell, width: '220px', locked: true, title: "Actions",  ignoreCheckbox: true, },
      ],
      dataItems: [],
    };
  },
 
  methods: {
    sensors: function (h, tdElement, props) {
      const field = props.field;
      var value = props.dataItem[field];
      if (!value) {
        return h("td", {}, "");
      }
      let arrayValue =  Array.isArray(value)?value:value.split(',')
      const numArr = arrayValue ? arrayValue : [];
      if(this.initialData.sensors) {
        const arr = this.initialData.sensors.filter((dev) =>{ 
        return numArr.includes(dev.id + '');
      });
      const names = arr.map(a => a.name).join(',');
      return h("td", {}, names ? names : numArr.join(','));
      }
      
    },
    tenants: function(h, tdElement, props) {
      const field = props.field;
      var value = props.dataItem[field];
      if (!value) {
        return h("td", {}, "");
      }
      if(this.initialData.tenants) {
        const tenant = this.initialData.tenants.find((t) => t.id === value);
        return h("td", {}, tenant ? tenant.name : '');
      }
    },
    device: function(h, tdElement, props) {
      const field = props.field;
      var value = props.dataItem[field];
      if (!value) {
        return h("td", {}, "");
      }
      const device = this.initialData.deviceTypes.find((t) => t.id === value);
      return h("td", {}, device ? device.name : '');
    },
    sortChangeHandler: function(e) {
      this.sort = e.sort;
    },
    showErrors: function() {
      this.$refs.rosterErros.show();
    },
     uploadTemplate(e) {
      this.$store.dispatch("device/uploadTemplate", e);
      this.$refs.templateUpload.value = "";
    },
    // pageChangeHandler: function(event) {
    //   this.skip = event.page.skip;
    //   this.take = event.page.take;
    // },
    showAdd: function() {
      this.add = true;
    },
    goToAddPage: function() {
      this.$router.push({ name: "deviceAddUpdate", params: { add: true } });
    },
    remove: function(item) {
      this.dataItems = item;
      this.$refs.form.openWindow();
    },
    OkMethod() {
      let item = this.dataItems;
      if(item.dataItem.vehicleRtoNumber){
        notifyWarn("Device is Mapped to Vehicle, Not able to delete")
      }
      else{
      return this.$store
        .dispatch("device/deleteDevice", item)
        .then(() => {
          notify(MESSAGES.DELETE_SUCCESS);
        })
        .catch(notifyApiError);
      }
    },
    edit: function(item) {
      return this.$store.dispatch("device/editDevice", item.dataItem); //item.dataItem.id
    },
    columnChange: function (e) {
      if (e.item.checked) {
        e.item.hidden = false;
      } else {
        e.item.hidden = true;
      }
      localStorage.setItem(
        LOCAL_STORAGE_KEYS.DRIVER_MANAGEMENT, 
        JSON.stringify(this.filteredColumns)
      );
    },
    exportExcel(){
      let arr = this.devices.map(it => {
        return {
          ...it,
          sensors: it.sensors ? this.initialData.sensors.filter((dev) =>
            it.sensors.includes(dev.id + '')
          ).map(a => a.name).join(','): '',
          tenantId: it.tenantId?this.initialData.tenants.filter((dev) =>
            it.tenantId.includes(dev.tenantId + '')
          ).map(a => a.name).join(','): '',
          deviceTypeId: it.deviceTypeId ? this.initialData.deviceTypes.filter((dev) =>
            it.deviceTypeId.includes(dev.id + '')
          ).map(a => a.name).join(','): '',
        }
      });
      saveExcel({
        data: arr,
        fileName: "Device",
        columns:this.columns
      });
    },
    goToExport(){
      this.$store.dispatch("device/export",this.serverSearchText)
    },
    downloadTemplate(){
      this.$store.dispatch("device/DownloadTemp");
    },
    getDate: function(h, tdElement, props) {
      let date = props.dataItem[props.field];
      if (date) {
        if (date.charAt(date.length - 1) === 'Z') {
          date = moment(date).format("MM/DD/YYYY");
        } else {
          date = moment(date + 'Z').format("MM/DD/YYYY");
        }
      }
      return h("td", {}, date ? date.toString() : "");
    },
    getVendorInfo: function(h, tdElement, props) {
      let vendorId = props.dataItem[props.field];
      const vendor = this.vendors.find((v) => v.id === vendorId);
      return h("td", {}, vendor ? vendor.name : '');
    },
    getDataOnload() {
      this.$store.dispatch("device/getDevices",this.devices);
      this.$store.dispatch("device/getInitialData", this.initialData)
    },
    async getAuditLog(e){
      let imei = e.dataItem.imei
      await this.$store.dispatch('device/getAudit', imei).then((res) => {
        this.auditVals=res.data.result
      })
    },
    pageChangeHandler: function(event) {
        let data=event
        this.$store.dispatch("device/pageChange",data)
      
       },
       clearSearchValue(){
     this.serverSearchText=""
     this.$store.dispatch("device/clearData");

    },
    searchEnterClicked(e) {
      let searchText=e
        this.$store.dispatch("device/searchReports", searchText)

      },
  },
  computed: {
    ...mapState([ 'loader', "EmployeeErrors", "devices", "initialData","pageSize","pageable","skip","take","totalCount"]),
    // ...mapGetters(["getDevices", "getSensors", "getTenants"]),
    // total() {
    //   return this.devices ? this.devices.length : 0;
    // },
    items: {
      get: function() {
        // return orderBy(
        //   this.deviceListVal.slice(this.skip, this.take + this.skip),
        //   this.sort
        // );
        return this.deviceListVal
      },
    },
   deviceListVal() {
    //  this.devices.map(device => {
    //   if(device.tenantId && this.initialData.tenants) {
    //     device.tenantName= this.initialData.tenants.find((t) => t.id === device.tenantId);
    //     device.tenantName= device.tenantName.name
    //   }
    //   if(device.deviceTypeId && this.initialData.deviceTypes) {
    //     device.deviceType= this.initialData.deviceTypes.find((t) => t.id === device.deviceTypeId);
    //   }
    //   if(device.sensors && this.initialData.sensors) {
    //     device.sensorName= this.initialData.sensors.find((t) => t.id.toString() === device.sensors);
    //   }
      //  device.sensorName= this.initialData.sensors.find((t) => t.id === device.sensors);
      //  device.deviceType= this.initialData.deviceTypes.find((t) => t.id === device.deviceTypeId);
    //  })
    //  return this.devices.filter((data) =>JSON.stringify(data).toLowerCase().indexOf(this.serverSearchText.toLowerCase()) !== -1);
     return this.devices.filter((data) =>JSON.stringify(data).toLowerCase());

   },
  },
  created: function() {
    this.unsubscribe = this.$store.subscribe((mutation) => {
      if (mutation.type == "setSeclectedFacility") {
        // this.loadVendor();
  
      }
    });
  },
  beforeDestroy() {
    this.unsubscribe();
    this.$store.dispatch("device/clearData");

  },
  mounted() {
    this.getDataOnload();
  },
  beforeMount() {
    const eListColumns = JSON.parse(
      localStorage.getItem(LOCAL_STORAGE_KEYS.DRIVER_MANAGEMENT)
    );
    if (!eListColumns) {
      this.filteredColumns = this.columns;
    } else {
      let items = [];
      this.columns.map((col, i) => {
        const obj = eListColumns.find(c => c.field === col.field);
        // Ignoring last column
        if (i < this.columns.length - 1)
          if (obj) {
            items.push({
              ...col,           
              hidden: obj.hidden,
              checked: obj.checked,
            });
          } else {
            items.push({...col});
          }
      });
      // adding ignored last column
      items.push(this.columns[this.columns.length - 1]);
      this.filteredColumns = items;
    }
  }
};
</script>

<style lang="scss" scoped>
 .search_mobile{width: 15% !important; border-radius: 5px;}
@media only screen and (max-width: 768px) {
 .search_mobile{width: 40% !important;}
 .mobile_hide_show{display: none;} 
 .driver_header_mobile{flex-direction: row !important; padding: 10px 10px 10px 10px;}
 .page-header .title-text {font-size: 12px;}
}

</style>

<style>
  .k-grid tr {
    height: 40px;
  }
</style>
